import { type ReactNode } from 'react';
import { Spinner } from '@/components/ui/spinner';
import { useAuth } from '@/hooks/use-auth';
import { useSelectedMember } from '@/hooks/use-selected-member';
// Task 31.6.2: admin click-through to the shared detail modal — documented exception.
// eslint-disable-next-line no-restricted-imports
import { ApproacherDetailModal } from '@/modules/admin/components/approacher-detail-modal';
import { useTeamMembers } from '../hooks/use-team-members';
import { VerificationPrompt } from './verification-prompt';
import { RoleSections, mergeAdmins, filterSelf } from './team-role-sections';

function AdminMemberModal(): ReactNode {
  const { selectedId, setSelectedId } = useSelectedMember();
  return (
    <ApproacherDetailModal
      approacherId={selectedId}
      onClose={() => setSelectedId(null)}
    />
  );
}

export function TeamPage(): ReactNode {
  const { data, isLoading } = useTeamMembers();
  const { user, isAdmin } = useAuth();
  const { setSelectedId } = useSelectedMember();
  if (isLoading) return <Spinner />;
  const merged = mergeAdmins(data);
  const isVerifying = user?.account_status === 'verifying';
  const pre = filterSelf(merged['pre_collectors'] ?? [], user?.id, isVerifying);
  const onSelect = isAdmin
    ? (id: string): void => setSelectedId(id)
    : undefined;

  return (
    <div className="space-y-lg">
      {isVerifying && <VerificationPrompt />}
      <RoleSections
        merged={merged}
        pre={pre}
        userId={user?.id}
        {...(onSelect && { onSelect })}
      />
      {isAdmin && <AdminMemberModal />}
    </div>
  );
}
